import React, {useState,useEffect} from 'react';
import webapi from '../../../api/webapi';
import SurfParameterBox from './SurfParameterBox';
import SurfResult from './SurfResult';
import EmptyDiv from '../Footer/EmptyDIV';
import Loading from '../modal/Loading';

const SurfBody = (props) =>{
    const [pageData,setPageData]=useState(undefined);
    const [selectedBookGroup,setSelectedBookGroup]=useState(1);
    const [selectedBook,setSelectedBook]=useState(undefined);
    const [selectedChapter,setSelectedChapter]=useState(undefined);
    const [loadingShow,setLoadingShow] = useState(false);

    useEffect(() => {
        // fetch('https://geolocation-db.com/json/')
        //     .then(response => {
        //         return response.json();
        //     }, "jsonp")
        //     .then(res => {
        //         setLog('pages/log/Surf/visit/'+res.IPv4.replaceAll('.',','))
        //     })
        //     .catch(err => setLog('pages/log/Surf/visit/'+err));
    
        getPage();
        
        async function getPage() {
            if (props.languageInfo!==undefined)
            {
                let pageList = await webapi.get('pages/datapages/201/'+props.languageInfo[0].Code);
                setPageData(pageList.data)
            }else{
                const pageList = await webapi.get('pages/datapages/201/fa');
                setPageData(pageList.data)
            }
        }
    },[props]);  

    // async function setLog(Data){
    //     await webapi.post(Data);
    // }

    // const setSelectedBookGroup = (selected)=>{
    //     setSelectedBookGroup(selected);
    // }

    // const setSelectedBook = (selected)=>{
    //      setSelectedBook(selected);
    // }

    // const setSelectedChapter = (selected)=>{
    //     setSelectedChapter(selected);
    // }

    if (pageData && props.languageInfo) {
        return (
            [
                <div>
                    <div className="container-fluid" id="innerpage_row_1">
                        <div className="container">
                        <h1 id="page_title">{pageData.length!==0 && pageData[0].F201!== undefined?pageData[0].F201:201/*جستجوی متن*/}</h1>
                        <h2 id="page_title_dek">{pageData.length!==0 && pageData[0].F20100!== undefined?pageData[0].F20100:20100/*آوانویسی و ترجمه فارسی متون فارسی میانه*/}</h2>
                        <hr className="halfwidth" />
                        </div>
                    </div>
                    <SurfParameterBox   setSelectedBookGroup={setSelectedBookGroup}
                                        setSelectedBook={setSelectedBook}
                                        setSelectedChapter={setSelectedChapter}
                                        setLoadingShow = {setLoadingShow}
                                        pageData={pageData}
                                        lang = {props.languageInfo[0].Code}
                    />
                    <br />
                    {
                        selectedChapter
                        ?
                        <SurfResult     pageData={pageData}
                                        selectedBook={selectedBook}
                                        selectedChapter={selectedChapter}
                                        selectedBookGroup={selectedBookGroup}
                                        setLoadingShow = {setLoadingShow}
                        />
                        :
                        <EmptyDiv />
                    }
                    <br />
                </div>
                ,
                loadingShow
                ?
                <Loading loadingShow = {loadingShow} />
                :
                null
            ]
        )
    }
    // else
    // {
    //     return (
    //         <EmptyDiv />
    //     )
    // }
 }

 export default SurfBody;